const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const buildUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

const handleResponse = async (response) => {
  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Une erreur est survenue');
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

export const fetchTranslations = () => {
  return fetch(buildUrl('/api/translations')).then(handleResponse);
};

export const fetchTechnologies = () => {
  return fetch(buildUrl('/api/technologies')).then(handleResponse);
};

export const fetchProjects = () => {
  return fetch(buildUrl('/api/projects')).then(handleResponse);
};

export const fetchProjectCategories = () => {
  return fetch(buildUrl('/api/projects/categories')).then(handleResponse);
};

export const fetchFormations = () => {
  return fetch(buildUrl('/api/formations')).then(handleResponse);
};

export const fetchExperiences = () => {
  return fetch(buildUrl('/api/experiences')).then(handleResponse);
};

export const trackPageview = (path, referrer) => {
  return fetch(buildUrl('/api/track'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ path, referrer })
  }).catch(() => {});
};
